import {useQuery} from "@tanstack/react-query";
import {getTopGamesService} from "../../services/games/gamesList/topGames.service";

export const useGetTopGames = (params = {}) => {
  const {data, isPending} = useQuery({
    queryKey: ["topGames", params],
    queryFn: () => getTopGamesService(params),
  });
  return {
    data,
    isPending,
  };
};
